module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error"
  }, [_c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "grid"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-6"
  }, [_c('visual', {
    attrs: {
      "image": "/static/images/404_image.jpg",
      "alt": "page not found 404"
    }
  }), _c('p', {
    staticClass: "message"
  }, [_vm._v("You can go back to the page that brought you here, or you can look for the page you want using our site search.")])], 1)])]), _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v("Sorry, we couldn't find the page you were looking for!")]), _c('h2', [_c('b', [_vm._v(" Error code: 404 ")]), _vm._v(" "), _c('br')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0db80d9a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error.vue
// module id = 214
// module chunks = 1